import type { FirmFile } from "@/lib/types";
import { getFirmFileDisplayName } from "@/lib/utils/firmFile";
import { getFileDocumentFormat } from "@/lib/utils/matterFile";
import type { Dispatch, SetStateAction } from "react";

type UseFirmFilePreviewArgs = {
  canDocumentEdit: boolean;
  canUpdate: boolean;
  selectedFile: FirmFile | undefined;
  setDocxEditorFile: Dispatch<SetStateAction<FirmFile | null>>;
  setPdfEditorFile: Dispatch<SetStateAction<FirmFile | null>>;
};

export function useFirmFilePreview({
  canDocumentEdit,
  canUpdate,
  selectedFile,
  setDocxEditorFile,
  setPdfEditorFile,
}: UseFirmFilePreviewArgs) {
  const previewFile =
    selectedFile?.presignedUrlKey && !selectedFile.isFolder
      ? {
          fileName: getFirmFileDisplayName(selectedFile),
          fileId: selectedFile.id,
          presignedURLKey: selectedFile.presignedUrlKey,
        }
      : undefined;
  const extension = selectedFile
    ? getFileDocumentFormat({
        ...selectedFile,
        name: getFirmFileDisplayName(selectedFile),
      })
    : "";
  const isSelectedDocx = extension.toLowerCase() === "docx";
  const isSelectedPdf = extension.toLowerCase() === "pdf";
  const canEditSelectedDocx = canUpdate && canDocumentEdit && isSelectedDocx;
  const canEditSelectedPdf = canUpdate && canDocumentEdit && isSelectedPdf;

  return {
    canEditSelectedDocx,
    canEditSelectedPdf,
    handleOpenDocxEditor: () => {
      if (selectedFile && canEditSelectedDocx) setDocxEditorFile(selectedFile);
    },
    handleOpenPdfEditor: () => {
      if (selectedFile && canEditSelectedPdf) setPdfEditorFile(selectedFile);
    },
    isSelectedDocx,
    isSelectedPdf,
    previewFile,
  };
}
